export type DeployBuildMeta = {
  version: string;
  builtAt?: string;
};

/** Versão injetada no index.html pelo release.py (produção). */
export function readEmbeddedBuildMeta(): DeployBuildMeta | null {
  const globalMeta = (
    window as Window & { __DOM_BELLONI_BUILD__?: DeployBuildMeta }
  ).__DOM_BELLONI_BUILD__;
  if (globalMeta?.version) {
    return globalMeta;
  }

  const match = document.documentElement.innerHTML.match(
    /dombelloni-deploy:([^:]+):/
  );
  if (match?.[1]) {
    return { version: match[1] };
  }

  return null;
}
